import { render, staticRenderFns } from "./IvtListUI.vue?vue&type=template&id=538568ca&scoped=true&"
import script from "./IvtListUI.vue?vue&type=script&lang=ts&"
export * from "./IvtListUI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538568ca",
  null
  
)

export default component.exports